module.exports = __webpack_public_path__ + "ef24292cf92ff934f7f90546f54b7665.pdf";